import styled from "styled-components";

import appFlowContainerBg from "assets/images/appFlowBg.png";
import { MAIN_THEME } from "styles/colors";

const Container = styled.div`
	display: flex;
	width: 100vw;
	height: 100vh;
	background: ${MAIN_THEME.DARK_BG};
	position: relative;
`;

const InnerContainer = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	position: relative;
	z-index: 1;
`;

interface Props {
	children?: JSX.Element | Array<JSX.Element>;
}

const AppFlowContainer = (props: Props): JSX.Element => {
	const { children } = props;

	return (
		<Container>
			<InnerContainer>{children}</InnerContainer>
		</Container>
	);
};

export default AppFlowContainer;
